export default "__VITE_ASSET__BDfv$RdV__"